// Přílohy Komunikace — sdílené pomůcky pro výběr, nahrání a zobrazení.
import { zmensitObrazek } from '../../../lib/obrazek';
import { hlavicky } from '../komunikace';

/** Co jde přiložit — fotky, video, PDF, Office, text (server hlídá totéž). */
export const PRIJIMANE = 'image/*,video/*,application/pdf,text/plain,text/csv,.doc,.docx,.xls,.xlsx,.ppt,.pptx';
export const MAX_PRILOH = 10;
// PHP na produkci bere nejvýš 12 MB (upload_max_filesize), víc server ani nepřečte.
export const MAX_MB = 12;

const jeHeic = (f) => /heic|heif/i.test(f.type) || /\.(heic|heif)$/i.test(f.name || '');

/**
 * Fotka z telefonu je klidně 12 Mpx a 5 MB — na server stačí 2048 px. HEIC
 * (iPhone) se převádí vždy, i malý: prohlížeče mimo Safari ho nezobrazí a GD
 * na serveru ho nepřečte. iOS ho přes `createImageBitmap` dekódovat umí.
 */
export async function pripravitSoubor(file) {
    if (!file?.type?.startsWith('image/') && !jeHeic(file)) return file;
    if (jeHeic(file)) {
        try {
            const bitmap = await createImageBitmap(file);
            const scale = Math.min(1, 2048 / Math.max(bitmap.width, bitmap.height));
            const canvas = document.createElement('canvas');
            canvas.width = Math.round(bitmap.width * scale);
            canvas.height = Math.round(bitmap.height * scale);
            canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
            bitmap.close?.();
            const blob = await new Promise(res => canvas.toBlob(res, 'image/jpeg', 0.85));
            if (blob) return new File([blob], file.name.replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' });
        } catch { /* pošli originál, server ho uloží jako soubor */ }
        return file;
    }
    return zmensitObrazek(file, 2048, 0.85);
}

/** Nahraje jeden soubor; vrátí přílohu z API nebo vyhodí chybu s hláškou pro člověka. */
export async function nahratPrilohu(file, typ) {
    const pripraveny = await pripravitSoubor(file);
    if (pripraveny.size > MAX_MB * 1024 * 1024) throw new Error(`${file.name}: soubor je větší než ${MAX_MB} MB.`);
    const fd = new FormData();
    fd.append('soubor', pripraveny);
    fd.append('typ', typ);
    const res = await fetch('/api/prilohy', { method: 'POST', headers: hlavicky(false), body: fd });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const zprava = data.error || data.errors?.soubor?.[0] || data.message
            || (res.status === 413 ? 'Soubor je na server moc velký.' : 'Nahrání se nepovedlo.');
        throw new Error(`${file.name}: ${zprava}`);
    }
    return data;
}

/** Odebere nahranou, ještě nepřipojenou přílohu (zavřený formulář, křížek). */
export function odebratNahranou(id) {
    return fetch(`/api/prilohy/${id}`, { method: 'DELETE', headers: hlavicky() }).catch(() => {});
}

export function velikost(b) {
    if (!b && b !== 0) return '';
    if (b < 1024) return `${b} B`;
    if (b < 1024 * 1024) return `${Math.round(b / 1024)} kB`;
    return `${(b / 1024 / 1024).toFixed(1).replace('.', ',')} MB`;
}
